import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SnotifyService } from 'ng-snotify';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { RowActionCallback } from 'src/app/shared/base-reporting/models/row-action-callback.interface';
import { RowAction } from 'src/app/shared/base-reporting/models/row-actions.interface';
import { FilterItem } from 'src/app/shared/base-reporting/models/filter-item.interface';
import { FilterCallback } from 'src/app/shared/base-reporting/models/filter-callback.interface';
import * as moment from 'moment';
import { BlogsService } from '../blogs.service';

@Component({
  selector: 'app-blog-list',
  templateUrl: './blog-list.component.html',
  styleUrls: ['./blog-list.component.css']
})
export class BlogListComponent implements OnInit {
  deleteRow: Article = {};
  private Data = [] as Array<TableViewItem>;
  viewFlag = false;
  viewAdminApprovalFlag = false;
  @ViewChild('viewLoc', { static: true }) viewLoc: ElementRef;
  @ViewChild('viewAdminApproval', { static: true })
  // tslint:disable-next-line: no-use-before-declare
  article = new Article();
  viewAdminApproval: ElementRef;
  tableColumns = [
    'title',
    'metaTitle',
    'metaDescription',
    'metaKeywords',
    'body',
    'coverPhoto',
    'authorId',
    'createdAt',
    'updatedAt'
  ];
  rowActions: Array<RowAction> = [
    {
      type: 'icon',
      slug: 'editBlog',
      class: 'btn',
      iconClasses: 'fa fa-edit'
    },
    {
      type: 'icon',
      slug: 'deleteBlog',
      class: 'btn',
      iconClasses: 'fa fa-trash'
    }
  ];
  reportFilter: Array<FilterItem> = [
    {
      fieldName: 'authorId',
      fieldDisplayName: 'Author ',
      fieldType: 'text'
    },
    {
      fieldName: 'createdAt',
      fieldDisplayName: 'Created At ',
      fieldType: 'daterange'
    },
  ];

  currentFilterObject = {} as FilterModel;
  constructor(
    private blogsApi: BlogsService,
    private notifier: SnotifyService,
    private router: Router,
    private datePipe: DatePipe
  ) {}

  returnedArticle(event) {
    // console.log(event.groupRow)
    if (event.editFlag === true) {
      this.router.navigateByUrl('/settings/blogs/edit/' + event.groupRow.id);
    } else {
      this.deleteRow.id = event[`groupRow`].id;

      this.deleteGroup(this.deleteRow);
    }
  }

  deleteGroup(row) {
    this.blogsApi.deleteArticle(row.id).subscribe(Response => {
      // console.log(Response);
      this.notifier.success(
        'Article ' + row.title + ' Has Deleted SuccessFully '
      );
    });
  }

  get data(): Array<TableViewItem> {
    return this.Data.filter(row => {
      if (
        this.currentFilterObject.createdAt &&
        this.currentFilterObject.createdAt.startDate &&
        this.currentFilterObject.createdAt.endDate
      ) {
        return moment(row.createdAt).isBetween(
          // @ts-ignore
          this.currentFilterObject.createdAt.startDate._i,
          // @ts-ignore
          this.currentFilterObject.createdAt.endDate._i
        );
      } else {
        return true;
      }
    }).filter(row => {
      if (this.currentFilterObject.authorId) {
        return row.authorId.includes(
          this.currentFilterObject.authorId
        );
      }
      return true;
    });
  }
  set data(v: Array<TableViewItem>) {
    this.Data = v;
  }

  ngOnInit() {
    // this.sharedService.getLanguages().then(response => {
    //   this.reportFilter[1].options = response.data.languages.map(l => ({value: l.id, display: l.name}))
    // })

    this.fetchAllArticles();
  }

  onFilter(event: FilterCallback) {
    this.currentFilterObject = event.filter;
  }

  private fetchAllArticles() {
    this.blogsApi.getArticles().subscribe(response => {
      // console.log(response)
      this.data = response.data.articles.map(r => {
        const date = this.datePipe.transform(r.createdAt, 'dd-MM-yyyy');
        const date2 = this.datePipe.transform(r.updatedAt, 'dd-MM-yyyy');
        return {
          id: r.id,
          title: r.title,
          metaTitle: r.metaTitle,
          metaDescription: r.metaDescription,
          metaKeywords: r.metaKeywords,
          authorId: r.authorId,
          body: r.body,
          coverPhoto: r.coverPhoto,
          createdAt: r.createdAt,
          updatedAt: r.updatedAt
        } as TableViewItem;
      });
    });
  }
  rowActionCB(event: RowActionCallback) {
    switch (event.action) {
      case 'editBlog':
        this.article = event.on;
        this.router.navigateByUrl('/settings/blogs/edit/' + this.article.id);
        break;
      case 'deleteBlog':
        this.article = event.on;
        this.deleteRow.id = this.article.id;
        this.deleteGroup(this.deleteRow);

        break;
      default:
        console.error('this is a mistake!');
    }
  }
  fetchTable(event) {
    if (event[`flag`] === true) {
      this.fetchAllArticles();
    }
  }
}

interface TableViewItem {
  metaTitle?: string;
  metaDescription?: string;
  metaKeywords?: string;
  body?: string;
  coverPhoto?: string;
  authorId?: string;
  createdAt?: string;
  updatedAt?: string;
}

interface FilterModel {
  authorId?: string;
  createdAt?: DateRangeModel;
}

export class Article {
  id?: string;
  title?: string;
  metaTitle?: string;
  metaDescription?: string;
  metaKeywords?: string;
  coverPhoto?: string;
  body?: string;
  authorId?: string;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string;
  /**
   *
   */
  constructor() {
    this.id = '';
    this.title = '';
    this.metaTitle = '';
    this.metaDescription = '';
    this.metaKeywords = '';
    this.coverPhoto = '';
    this.body = '';
    this.authorId = '';
    this.createdAt = '';
    this.updatedAt = '';
    this.deletedAt = '';
  }
}
interface DateRangeModel {
  startDate?: moment.Moment;
  endDate?: moment.Moment;
}
